import api from "./utils/api";
import { getAuthToken } from "./utils/tokens";
// FOR ADMINS ONLY ("CREATE A NEW PRODUCT")
const createProduct = async (product) => {
  try {
    if (!product) throw new Error("Missing userId or product data");
    const token = getAuthToken();
    if (!token) throw new Error("Unauthorized: No token found");
    // Prepare FormData
    const formData = new FormData();
    formData.append("name", product.name);
    formData.append("description", product.description);
    formData.append("price", product.price);
    formData.append("category", product.category);
    formData.append("quantity", product.quantity || product.Quentity);
    formData.append("shipping", product.shipping);
    formData.append("sold", product.sold);

    // Append the photo if available
    if (product.photo) {
      formData.append("photo", product.photo);
    }

    // Append multiple images
    if (product.photos && product.photos.length > 0) {
      product.photos.forEach((file) => {
        formData.append("photos", file); // Append each file
      });
    }

    // Send request with FormData
    const response = await api.post(`/product/create/`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data", // Required for FormData
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error adding product:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// FOR ADMINS ONLY ("UPDATE A PRODUCT")
const updateProduct = async (productId, formData) => {
  try {
    if (!productId || !formData)
      throw new Error("Missing productId or form data");
    const token = getAuthToken();
    if (!token) throw new Error("Unauthorized: No token found");

    const response = await api.put(`/product/${productId}`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error updating product:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// FOR ADMINS ONLY ("DELETE A PRODUCT")
const deleteProduct = async (productId) => {
  try {
    const token = getAuthToken();
    const response = await api.delete(`/product/${productId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
// **************************************************
// PUBLIC ROUTES
const getProducts = async ({
  page = 1,
  limit = 8,
  categories,
  minPrice,
  maxPrice,
  search,
  sortBy = "createdAt",
  order = "desc",
  stockStatus,
} = {}) => {
  try {
    let queryParams = new URLSearchParams();

    // Add pagination params
    queryParams.append("page", page);
    queryParams.append("limit", limit);

    // Add filter params
    if (categories) queryParams.append("categories", categories);
    if (minPrice) queryParams.append("minPrice", minPrice);
    if (maxPrice) queryParams.append("maxPrice", maxPrice);
    if (search) queryParams.append("search", search);
    if (stockStatus) queryParams.append("inStock", stockStatus);

    // Add sorting params
    queryParams.append("sortBy", sortBy);
    queryParams.append("order", order);
    const response = await api.get(`/products?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getProductById = async (productId) => {
  try {
    const response = await api.get(`/product/${productId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getAllProductsCategories = async () => {
  try {
    const response = await api.get("/products/categories");
    return response.data;
  } catch (error) {
    throw error;
  }
};

const searchProducts = async (search, page = 1, limit = 8) => {
  try {
    const response = await api.get(
      `/products/search?search=${search}&page=${page}&limit=${limit}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getRelatedProducts = async (productId) => {
  try {
    const response = await api.get(`/products/relate/${productId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
const getProductPhoto = async (productId) => {
  try {
    const response = await api.get(`/products/photo/${productId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const advancedSearchProducts = async (params) => {
  try {
    const response = await api.post("/products/by/search", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export {
  createProduct,
  updateProduct,
  deleteProduct,
  getProducts,
  getProductById,
  getAllProductsCategories,
  searchProducts,
  getRelatedProducts,
  getProductPhoto,
  advancedSearchProducts,
};
